/**
 * Created by lihanying on 2017/6/29.
 */
import { GETCLUBREVENUE } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBREVENUE:
      return Object.assign({}, state, { revenueList: action.payload })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubRevenue/reduce.js